export const isAuthenticationRedirectUrl = () => {
  const query = window.location.search;

  return {
    isAuth0SuccessRedirection:
      query.includes("code=") && query.includes("state="),
    isAuth0FailureRedirection: query.includes("error=unauthorized"),
  };
};
